import React from "react";
import { ShieldAlert } from "lucide-react";
import { Button } from "./button";
import { Dialog, DialogContent, DialogFooter } from "./dialog";

// Read-only roles (Nurse/Patient) see this instead of a download actually happening (003 Role Gate).
export function AccessDeniedDialog({ open, onOpenChange, message }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm">
        <div className="flex flex-col items-center gap-3 py-2 text-center">
          <ShieldAlert className="h-14 w-14 text-red-500" />
          <div className="space-y-1">
            <h3 className="text-base font-semibold text-slate-900">Access Denied</h3>
            <p className="text-sm text-slate-500">
              {message || "Your role does not have permission to perform this action."}
            </p>
          </div>
        </div>
        <DialogFooter className="sm:justify-center">
          <Button type="button" className="w-full" onClick={() => onOpenChange(false)}>OK</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
